import React from 'react';
import { graphql } from "gatsby";
import { makeStyles } from '@material-ui/styles';
import {buildBlocks} from "../../../services/builder";
import styles from './styles';

const useStyles = makeStyles(theme => styles(theme));

export const CgbBlogPostWrapBlock = (props) => {
    const blocks = buildBlocks(props.innerBlocks, props.parentAttributes, props.pageContext);
    const classes = useStyles();

    return <div className={`blog-post-wrapper ${props.attributes.className ? props.attributes.className : ''} ${classes.blogPostWrapper}`}>
        <div className="container">
            {blocks.map((block) => {
                return block;
            })}
        </div>
    </div>
};

export const CgbBlogPostWrapBlockFragment = graphql`
  fragment CgbBlogPostWrapBlock on WpBlock {
    ... on WpCgbBlogPostWrapBlock {
        name
        attributes {
            className
        }
      }
  }`;

// This is the string version of this that is used within previews and without WP prefixes
export const CgbBlogPostWrapBlockPreview = `
    ... on CgbBlogPostWrapBlock {
        name
        attributes {
            className
        }
    }
`;